<template>
	<div class="card my-4 vue-user-profile-extra">
		<div class="card-header">
			<a name="upload" />
			{{ __("File uploads") }}
		</div>
		<div class="card-body p-3">
			<span
				><!-- TODO translate -->
				{{
					__(
						"These files will be published in your profile and will be available to your trading partners for smooth processing. Download here purchase conditions, directions etc."
					)
				}}
				<a v-bind:href="selbsterklaerungCcUrl" target="_blank">{{
					__("Template self-declaration cross compliance farms")
				}}</a>
			</span>

			<div class="alert alert-secondary mt-4" v-if="isLoading">
				{{ __("Currently Loading...") }}
			</div>
			<div v-else>
				<crop-modal
					ref="deleteModal"
					v-if="maybeDelete != null"
					:confirm-label="__('Delete')"
					v-on:confirm="deleteUpload(maybeDelete)"
					v-on:dismiss="maybeDelete = null"
				>
					{{ __("Should this upload really be deleted?") }}
				</crop-modal>

				<ul class="list-group existing-files-list mt-3">
					<li
						class="list-group-item"
						v-for="upload in uploads"
						:key="upload.id"
					>
						<div class="float-right">
							<button
								type="button"
								class="btn btn-secondary btn-sm"
								v-on:click="maybeDelete = upload"
							>
								{{ __("Delete") }}
							</button>
						</div>
						<a
							v-bind:href="endPoint + '/' + upload.id + '/download'"
							target="_blank"
						>
							{{ upload.filename }}
							<span v-if="upload.label_id">({{ __(upload.label_id) }})</span>
							<span v-else-if="upload.label">({{ upload.label }})</span>
						</a>
					</li>
				</ul>

				<crop-upload
					v-bind:class="{ 'mt-3': uploads.length > 0 }"
					v-bind:publicUpload="true"
					v-bind:showUploadedFile="false"
					v-on:new-upload="handleNewUpload"
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {},
	data() {
		return {
			isLoading: true,
			uploads: [],
			endPoint: window.baseUrl + "/api/user_upload",
			maybeDelete: null,
		};
	},
	async created() {
		const uploads = await axios.get(this.endPoint);
		this.uploads = uploads.data.data;
		this.isLoading = false;
	},
	computed: {
		selbsterklaerungCcUrl() {
			return window.baseUrl + "/documents/Selbsterklaerung_CC.pdf";
		},
	},
	methods: {
		handleNewUpload(upload) {
			console.log("upload", upload);
			this.uploads.push(upload);
		},
		async deleteUpload(upload) {
			console.log("DELETE", upload);
			const resp = await axios.delete(this.endPoint + "/" + upload.id);
			console.log("DELETE RESP", resp);
			this.uploads = resp.data.data;
			this.maybeDelete = null;
		},
	},
};
</script>
